import React, { ReactNode } from "react";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import styles from "./Footer.module.scss";

interface Props {
  creating?: boolean;
  loading?: boolean;
  onCancel?: () => void;
  onSave?: () => void;
  saveDisabled?: boolean | ReactNode; // ReactNode means "disabled" + show a tooltip with the given message
}

const Footer: React.FC<Props> = ({ creating, loading, onCancel, onSave, saveDisabled }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <Button onClick={onCancel}>
        {intl.formatMessage({
          id: "map.territories.sidebar.create.footer.cancel",
          defaultMessage: "Cancel",
          description: "Cancel button in the Create Territory drawer in Territory Mode",
        })}
      </Button>
      <Tooltip title={saveDisabled === false || saveDisabled === true ? undefined : saveDisabled}>
        <Button disabled={!!saveDisabled} loading={loading} onClick={onSave} type="primary">
          {creating
            ? intl.formatMessage({
                id: "map.territories.sidebar.create.footer.ok.creating",
                defaultMessage: "Create Territory",
                description:
                  "Create Territory button in the Create Territory drawer in Territory Mode",
              })
            : intl.formatMessage({
                id: "map.territories.sidebar.create.footer.ok.updating",
                defaultMessage: "Save Changes",
                description:
                  "Update Territory button in the Create Territory drawer in Territory Mode",
              })}
        </Button>
      </Tooltip>
    </div>
  );
};

export default Footer;
